import { Component, Input } from '@angular/core';
import { CompanySellerDetails } from '../../../_services/admin-seller.service';
import { DocumentService } from '../../../_services/document.service';

@Component({
    selector: 'app-company-seller-detail',
    templateUrl: './company-seller-detail.component.html',
    styleUrls: ['./company-seller-detail.component.css'],
    standalone: false
})
export class CompanySellerDetailComponent {
    @Input() seller: CompanySellerDetails;

    constructor(private documentService: DocumentService) {}

    downloadDocument(documentId: string, documentPath: string): void {
        const fileName = documentPath.split('/').pop() || 'document';

        this.documentService.downloadDocumentAdminById(documentId).subscribe({
            next: (blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                console.error('Error downloading document');
            }
        });
    }

    getDocumentTypeLabel(documentType: string): string {
        switch (documentType) {
            case 'IdCard':
                return 'ID Card';
            case 'Passport':
                return 'Passport';
            case 'RegistrationCertificate':
                return 'NIU (Numéro d\'Identifiant Unique)';
            case 'TaxComplianceCertificate':
                return 'Tax Compliance Certificate';
            case 'RegistrationOfIncorporation':
                return 'Certificate of Incorporation';
            default:
                return documentType;
        }
    }
}
